module.exports = __webpack_public_path__ + "img/mob-clock-icon.1430e5f3.svg";